import React, { Fragment, useEffect, useState, useCallback } from 'react';
import FinaceSummaryCards from './FinanceSummaryCards';
import { Loader2 } from 'lucide-react';
import { Breadcrumbs } from '../../../AbstractElements';
import { GenerateFinanceReport, getFinanceSummary, requestWithdraw } from '../../../api-handle/financeApi';
import { axiosInstance } from '../../../api-handle/axiosInstance';
import PayoutsTable from './PayoutsTable.jsx';
import SubscriptionCards from '../MySubscriptions/SubscriptionCards.jsx';
import { toast } from 'react-toastify';

function Finance() {
    const [loading, setLoading] = useState(false);
    const [financeSummary, setFinanceSummary] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);

    const fetchFinanceSummary = async () => {
        try {
            setLoading(true);
            const revenue = await getFinanceSummary();
            setFinanceSummary(revenue);
        } catch (err) {
            console.error('Failed to fetch revenue summary:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPayouts = useCallback(async (status, page = 1, size = 10) => {
        try {
            const endpoint = status === 'completed'
                ? '/mp/finance/completed/payments'
                : '/mp/finance/pending/payments';

            const res = await axiosInstance.get(endpoint, {
                params: { page, size },
            });

            return {
                data: res?.data?.data?.withdrawRequests || [],
                pagination: res?.data?.data?.pagination || {},
            };
        } catch (err) {
            console.error(`Failed to fetch ${status} payouts:`, err);
            return { data: [], total: 0 };
        }
    }, []);

    const handleRequestWithdraw = async () => {
        try {
            if (financeSummary?.merchantBalance === 0) {
                toast.error("Your Available Balance Must be More then 0 to request a Withdraw!")
            } else {
                const res = await requestWithdraw()
                if (res.isSuccess) {
                    toast(res.message)
                }
            }

        } catch (error) {
            toast.error(error.message)
        }
    }

    useEffect(() => {
        fetchFinanceSummary();
    }, []);

    return (
        <div>
            <Fragment>
                <Breadcrumbs mainTitle="Finance" parent="Management" title="Finance Management" />
                {loading ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '60vh',
                        }}
                    >
                        <Loader2
                            size={48}
                            color="#33bdbf"
                            style={{
                                animation: 'spin 1s linear infinite',
                                filter: 'drop-shadow(0 0 6px #6366F1)',
                                transform: 'scale(1.1)',
                            }}
                        />
                    </div>
                ) : (
                    <>
                        {financeSummary && <FinaceSummaryCards data={financeSummary} />}

                        <button
                            onClick={async () => {
                                setDownloading(true);
                                setDownloadProgress(0);
                                try {
                                    await GenerateFinanceReport(percent => setDownloadProgress(percent));
                                } catch (err) {
                                    console.error('Failed to download report:', err);
                                } finally {
                                    setDownloading(false);
                                }
                            }}
                            style={{
                                backgroundColor: '#33bdbf',
                                color: '#fff',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '8px',
                                cursor: downloading ? 'not-allowed' : 'pointer',
                                fontSize: '0.95rem',
                                minWidth: '200px',
                                transition: 'all 0.3s ease',
                                opacity: downloading ? 0.8 : 1,
                            }}
                            disabled={downloading}
                        >
                            {downloading ? `Downloading...` : 'Download Finance Report'}
                        </button>

                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '1rem',
                                marginTop: '1.5rem',
                            }}
                        >
                            {/* <div style={{ border: '1px solid #ccc', borderRadius: '12px', padding: '1rem', flex: 1.5 }}>
                                <PayoutsTable title="Pending Payouts" status="pending" fetchData={fetchPayouts} />
                            </div> */}

                            <div style={{ border: '1px solid #ccc', borderRadius: '12px', padding: '1rem', flex: 2 }}>
                                <PayoutsTable title="Withdraw Requests" status="completed" fetchData={fetchPayouts} onRequestWithdraw={handleRequestWithdraw} />
                            </div>
                        </div>
                    </>
                )}
            </Fragment>
        </div>
    );
}

export default Finance;
